import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20 3H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-1 6H4V5h15v4zm1 4H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-1 6H4v-4h15v4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 15h15v4H4zM4 5h15v4H4z",
  opacity: ".3"
})), 'ViewAgendaTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewAgendaTwoTone.js
// module id = 7069
// module chunks = 2